module.exports = __webpack_public_path__ + "media/卫星遥感在环保领域应用.6b87100a.mp4";